var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.27778 16.444V16.444C5.29594 16.444 4.5 15.6481 4.5 14.6662V6.66623C4.5 6.43048 4.59365 6.20439 4.76035 6.03769C4.92705 5.87099 5.15314 5.77734 5.38889 5.77734H10.3889C12.0457 5.77734 13.3889 7.12049 13.3889 8.77734V16.444M9.83333 16.444H15.1667M18.7222 16.444V16.444C19.7041 16.444 20.5 15.6481 20.5 14.6662V11.1107M20.5 11.1107H13.3889M20.5 11.1107L18.7072 8.12275C18.1651 7.21913 17.1886 6.66623 16.1348 6.66623H13.3889",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.27783 16.4438C6.27783 16.9153 6.46513 17.3675 6.79853 17.7009C7.13193 18.0343 7.58411 18.2216 8.05561 18.2216C8.52711 18.2216 8.97929 18.0343 9.31269 17.7009C9.64609 17.3675 9.83339 16.9153 9.83339 16.4438C9.83339 15.9723 9.64609 15.5201 9.31269 15.1867C8.97929 14.8533 8.52711 14.666 8.05561 14.666C7.58411 14.666 7.13193 14.8533 6.79853 15.1867C6.46513 15.5201 6.27783 15.9723 6.27783 16.4438Z",
    stroke: "#00C170",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1665 16.4438C15.1665 16.9153 15.3538 17.3675 15.6872 17.7009C16.0206 18.0343 16.4728 18.2216 16.9443 18.2216C17.4158 18.2216 17.868 18.0343 18.2014 17.7009C18.5348 17.3675 18.7221 16.9153 18.7221 16.4438C18.7221 15.9723 18.5348 15.5201 18.2014 15.1867C17.868 14.8533 17.4158 14.666 16.9443 14.666C16.4728 14.666 16.0206 14.8533 15.6872 15.1867C15.3538 15.5201 15.1665 15.9723 15.1665 16.4438Z",
    stroke: "#00C170",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicle);
export default __webpack_public_path__ + "static/media/vehicle.d9f9d9653685b3e45c06914be88ab3ea.svg";
export { ForwardRef as ReactComponent };